import LoadingIndicator from '../components/loadingIndicator';

export const CommonLoadable = {
  loading: LoadingIndicator,
};
